var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useContext, useState } from 'react';
import 'dayjs/locale/fr-ca';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { useTranslation } from 'react-i18next';
import { ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Typography, } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import dayjs from 'dayjs';
import { CentralProviderContext } from '../../../centralProviderContext/CentralProviderContext';
export function ExpandablePanels(props) {
    dayjs.extend(localizedFormat);
    var t = useTranslation().t;
    var notes = props.notes;
    var _a = __read(useState(notes[0].id), 2), expanded = _a[0], setExpanded = _a[1];
    var centralProfile = useContext(CentralProviderContext).centralProfile;
    return (React.createElement(React.Fragment, null, notes.map(function (note) {
        var _a;
        var language = note.language.includes('fr') ? 'fr-ca' : 'en';
        // dayjs takes care of the translation and order of the date components.
        var date = dayjs(note.releaseDate).locale(language).format('LL');
        var appName = ((_a = centralProfile === null || centralProfile === void 0 ? void 0 : centralProfile.applications.find(function (a) { return a.app_key === note.application; })) === null || _a === void 0 ? void 0 : _a.name) || '';
        return (React.createElement(ExpansionPanel, { expanded: note.id === expanded, onChange: function () { return setExpanded(note.id); }, key: note.id },
            note.id !== expanded && (React.createElement(ExpansionPanelSummary, { expandIcon: React.createElement(ExpandMore, null) },
                React.createElement(Typography, null, date))),
            React.createElement(ExpansionPanelDetails, { style: { display: 'block' } },
                React.createElement(Typography, { style: { fontSize: 18, fontWeight: 'bold' } }, note.releaseVersion ? "".concat(t(appName), " - ").concat(note.releaseVersion) : t(appName)),
                React.createElement(Typography, { style: { fontSize: 12, marginBottom: 16, marginLeft: 2 } }, date),
                React.createElement(Typography, { style: { fontSize: 16 } }, note.title),
                React.createElement("div", { dangerouslySetInnerHTML: { __html: note.html } }))));
    })));
}
//# sourceMappingURL=ExpandablePanels.js.map